<template>
  <div>
    <ion-searchbar
      no-border
      v-ion-model="keywords"
      :debounce="600"
      @ionChange="search"
    ></ion-searchbar>

    <div class="notebook-select">
      <v-select label="label" :value="selectValue" @input="setSelected" :options="options" :searchable="false" :clearable="false" :appendToBody="true">
        <template #option="{ label, value, parent }">
          <div :class="value >= 1000 ? 'custom-categories' : 'default-categories'">
            <p v-if="parent" class="sub-categories">{{ label }}</p>
            <p v-else>{{ label }}</p>
          </div>
        </template>
      </v-select>
      <span></span>
    </div>

    <ion-list>
      <ion-item v-if="!count && selectMode"
        >You have no notebooks. Please create one first.
      </ion-item>

      <router-link to="/notebooks/edit" v-if="!count && selectMode">
        <ion-item button>
          Create a notebook.
        </ion-item>
      </router-link>

      <ion-item v-if="count && keywords"
        >{{ count }} match<span v-if="count > 1">es</span>&nbsp;found.</ion-item
      >
      <ion-item
        detail
        button
        v-for="(c, idx) in result"
        :key="idx"
        :href="`#/notebooks/${c.id}`"
        @click="viewDoc($event, c)"
      >
        <ion-grid when="sm" style="width:100%">
          <ion-row>
            <ion-col size-sm="7" size="12">
              <h2 class="list-title" v-html="c.title"></h2>
            </ion-col>
            <ion-col size-sm="3" size="12">
              <p class="no-margin">
                <span v-for="(tag, idx) in c.tags" :key="idx">{{ tag }}</span>
              </p>
            </ion-col>
            <ion-col size-sm="2" size="12">
              <ion-note>{{ formatDate(c.created_at) }}</ion-note>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-item>
    </ion-list>

    <button v-if="$config.mobile" @click="$router.push('/notebooks/edit')" class="floating-button ion-activatable">
      <ion-ripple-effect type="unbounded"></ion-ripple-effect>
      <ion-icon name="add"></ion-icon>
   </button>

    <ion-infinite-scroll
      ref="scoller"
      threshold="200px"
      @ionInfinite="loadNext"
    >
      <ion-infinite-scroll-content
        loadingSpinner="bubbles"
        loadingText="Loading more data..."
      >
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </div>
  
</template>
<script>
import debounce from "debounce";
import { format } from "date-fns";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  props: {
    selectMode: Boolean
  },

  data() {
    return {
      result: [],
      page: 0,
      keywords: "",
      count: 0,
      limits: 0,
      offset: 0,
      pages: 0,
      options: [
        {label: 'All', value: 1},
        {label: 'Political Law', value: 2},
        {label: 'Labor Law', value: 3},
        {label: 'Civil Law', value: 4},
        {label: 'Taxation Law', value: 5},
        {label: 'Commercial Law', value: 6},
        {label: 'Criminal Law', value: 7},
        {label: 'Remedial Law', value: 8},
        {label: 'Legal Ethics', value: 9},
        {label: 'Others', value: 10}
      ],
      category: 1,
      popupContent: true
    };
  },
  computed: {
    selectValue() {
      if(this.category) {
        const idx = this.options.findIndex(x => x.value === this.category);
        return this.options[idx];
      }
      return null;
    }
  },

  methods: {
    async _search(append = false) {
      if (!append) {
        this.page = 0;
      }

      var params = {
        _project: ["id", "title", "created_at", "category", "tags"],
        _sort: "updated_at:desc",
        _page: this.page
      };

      if (this.keywords) {
        params.title_regex = this.keywords;
      }

      if(this.category) {
        if(this.category !== 1) {
          params.category = this.category;
        }
      }
 
      var res = await this.$lawyerly.casebooks.search(params);

      this.count = res.data.count;

      if (append && res.data.result) {
        this.result = [...this.result, ...res.data.result];
      } else {
        this.result = res.data.result;
      }

      this.limits = res.data.limits;
      this.offset = res.data.offset;
      this.pages = this.count / (this.limits || 1);
      this.$refs.scoller.disabled = this.page >= this.pages;
      this.$store.commit("ui/setLastNotesQuery", this.keywords);
      this.$store.commit("history/addSearch", {key: this.keywords, type: "notebooks"});
    },

    async loadNext(evt) {
      this.page = this.page + 1;
      await this._search(true);
      evt.target.complete();
    },

    search: debounce(function() {
      this._search();
    }, 500),

    viewDoc(e, doc) {
      e.preventDefault();
      if (this.selectMode) {
        this.$emit("input", doc);
        return;
      }

      setTimeout(() => {
        this.$router.push(`notebooks/${doc.id}`);
      }, 350);
    },

    async setSelected(value) {
      if(value) {
        this.category = value.value;
      } else {
        this.category = null;
      } 
      await this._search();
    },

    new() {
      this.$router.push("/notebooks/edit");
    },

    onHeaderCommand(event, cmd) {
      switch (cmd.cmd) {
        case "new":
          this.new();
          break;
      }
    },

    formatDate(date) {
      return format(new Date(date.replace(' ', 'T')), "MMM. dd, yyyy hh:mm a");
    },
    async getCategories() {
      const res = await this.$http({
        method: "GET",
        url: this.$config.api.url + "/categories",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      });

      if(res) {
        if(res.data) {
          if(res.data.result.length > 0) {
            const categories = res.data.result;
            const opts = this.options;
            categories.forEach(el => {
              if(el.parent) {
                const idx = opts.findIndex(x => x.value === el.parent);
                opts.splice(idx+1, 0, {label: el.title, value: el.id, parent: el.parent});
              } else {
                opts.push({label: el.title, value: el.id});
              }
            });
          }
        }
      }
    }
  },

  mounted() {
    if (!this.selectMode) {
      this.$store.commit("ui/setHeaderTitle", "Search Notes");
      this.keywords = this.$store.state.ui.lastNotesQuery;
    }
    this._search();

    if(this.$route.path == "/notebooks") {
      this.$store.commit("ui/setMoreHeaderButtons", {
        mobile: [],
        web: [
          { label: "new", icon: "add-circle", disabled: false, emit: "header-command", cmd: "new" },
        ]
      });
      this.$root.$on("header-command", this.onHeaderCommand);
    }

    this.getCategories();
  },

  beforeDestroy() {
    if (!this.selectMode) {
      this.$store.commit("ui/setHeaderTitle", "");
    }
    if(this.$route.path == "/notebooks") {
      this.$store.commit("ui/setMoreHeaderButtons", {mobile: [], web: []});
      this.$root.$off("header-command", this.onHeaderCommand);
    }
  },

  components: {
    "v-select": vSelect
  }
};
</script>
<style>
h2.list-title {
  font-size: 14pt;
  margin: 0px;
}

.floating-button {
  padding: 0;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  position: fixed; 
  right: 10px; 
  bottom: 10px;
  background-color: rgb(23, 179, 145);
  box-shadow: 0 4px 16px rgba(0,0,0,0.12);
}

.floating-button ion-icon {
  font-size: 2.3em;
  color: #fff;
}

.notebook-select {
  max-width: 500px;
  padding: 0.5em;
  display: flex;
}

.v-select{
  flex: 1;
}

.vs__dropdown-option--highlight {
  background: var(--ion-color-primary);
}

.vs__dropdown-option {
  padding: 0.5em 0.5em;
}

.notebook-select span{
  flex: 1;
}

.sub-categories {
  margin: 0 0 0 1.3em !important;
}

.default-categories p, .custom-categories p{
  margin: 0;
  padding-left: 0.5em;
}

.custom-categories p {
  border-left: 2px solid var(--ion-color-primary);
}

</style>
